<template>
    <common-modal @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="large">
            <div class="availability-reschedule-modal__header">
                <common-icon name="white-warning" size="gigantic"></common-icon>
                <div class="appointment-length-modal__heading availability-reschedule-modal__heading">
                    <span class="appointment-length-modal__heading--bold">
                        {{ $tc('forms.auth.schedule.modals.reschedule.heading_1', numberOfAppointments) }}
                    </span>
                    <span>{{ $tc('forms.auth.schedule.modals.reschedule.heading_2', numberOfAppointments) }}</span>
                </div>
            </div>

            <common-content-spacer height="large" class="availability-reschedule-modal">
                <common-icon name="clock-reschedule" size="super-large"></common-icon>

                <p class="availability-reschedule-modal__content">
                    {{ $tc('forms.auth.schedule.modals.reschedule.content', numberOfAppointments) }}
                </p>
            </common-content-spacer>

            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.cancel')"
                    type="secondary"
                    size="large"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
                <common-button
                    :label="$tc('forms.auth.schedule.modals.reschedule.buttons.reschedule_them', numberOfAppointments)"
                    type="primary"
                    size="large"
                    @click="emitEvent({ name: 'reschedule' })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    export default {
        props: {
            numberOfAppointments: { type: Number, required: true },
        },
    }
</script>
